export default __webpack_public_path__ + "images/2c49906d1c49dd8cc95fa8f71f8d9a42-theatre.webp";